interface SelectProps {
  value: string
  initTimezone: string
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  data: {
    value: string
    abbr: string
    offset: number
    name: string
    isdst: boolean
    text: string
    utc: string
  }[]
}

export const TimeZoneSelect: React.FC<SelectProps> = ({
  value,
  handleChange,
  data,
  initTimezone,
}) => {
  return (
    <select
      id="timezones"
      name="timezone"
      className="border shadow-md rounded-md w-full order-blue-500 focus:border-blue-600 py-4 px-2 mt-2 mb-6"
      value={value}
      onChange={handleChange}
    >
      <option value="">
        {initTimezone ? initTimezone : 'Select a timezone'}
      </option>
      {data.map((timezone, index) => (
        <option key={index} value={timezone.utc}>
          {timezone.text}
        </option>
      ))}
    </select>
  )
}
